export enum SessionTypes {
    All = 0,
    Logged = 1,
    Guest = 2,
}
